
import React from 'react';
import { People, CheckCircle, Cancel, Person, SupervisorAccount } from '@mui/icons-material';

export const RolesStats = ({ stats }) => {
    const statItems = [
        {
            value: stats.total,
            label: 'Total Membres',
            icon: People,
            color: 'from-amber-500 to-orange-500',
            bgColor: 'bg-amber-500/10'
        },
        {
            value: stats.active,
            label: 'Actifs',
            icon: CheckCircle,
            color: 'from-green-500 to-emerald-500',
            bgColor: 'bg-green-500/10'
        },
        {
            value: stats.abandoned,
            label: 'Abandonnés',
            icon: Cancel,
            color: 'from-amber-500 to-yellow-500',
            bgColor: 'bg-amber-500/10'
        },
        {
            value: stats.revoked,
            label: 'Révoqués',
            icon: Cancel,
            color: 'from-red-500 to-orange-500',
            bgColor: 'bg-red-500/10'
        },
        {
            value: stats.admins,
            label: 'Administrateurs',
            icon: SupervisorAccount,
            color: 'from-blue-500 to-cyan-500',
            bgColor: 'bg-blue-500/10'
        },
        {
            value: stats.cashiers,
            label: 'Caissiers',
            icon: Person,
            color: 'from-teal-500 to-green-500',
            bgColor: 'bg-teal-500/10'
        }
    ];

    return (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
            {statItems.map((stat, index) => (
                <div
                    key={stat.label}
                    className={`${stat.bgColor} backdrop-blur-xl rounded-2xl p-4 border border-amber-100/70 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105`}
                >
                    <div className="flex items-center justify-between">
                        <div>
                            <div className="text-xl font-bold text-gray-900">{stat.value}</div>
                            <div className="text-xs text-gray-600 mt-1">{stat.label}</div>
                        </div>
                        <div className={`p-2 rounded-xl bg-gradient-to-r ${stat.color} shadow-md`}>
                            <stat.icon className="text-white text-lg" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};